import { RootState } from "../reducers";
import { TempSourceLayersItem } from "./tempSourceLayers";

export const getTempSourceLayers = ({ tempSourceLayers }: RootState): TempSourceLayersItem[] =>
  tempSourceLayers?.layers || [];
